import client from "services/ngage/api-client";
import DataPage from "types/DataPage";
import deserializeInteractionArea from "services/ngage/deserializers/interaction-area";
import {InteractionArea, InteractionAreaData} from "../../types/InteractionArea";
import DataResource from "../../types/DataResource";
import {parameters} from "../string";

type InteractionAreaFilters = {
    page?: number
    per_page?: number
    sites?: string
}

/**
 * Get all interaction areas (paginated)
 */
const all = async (page: number = 1) => {
    const response = await client.get<DataPage<InteractionArea> | null>(`/interaction-areas?page=${page}`)

    if(response.data){
        response.data.data = response.data.data.map(deserializeInteractionArea)
    }

    return response.data
}

/**
 * Get all Interaction Areas that match the given filters (paginated)
 */
const filtered = async (filters: InteractionAreaFilters = {}) => {
    const params = parameters(filters, {page: 1, per_page: 100});
    const response = await client.get<DataResource<InteractionArea> | null>('/interaction-areas', {params});

    if (response.data) {
        response.data.data = response.data.data.map(deserializeInteractionArea)
    }

    return response.data
}

/**
 * Get a single interaction area
 *
 * @param {number} id
 */
const get = async (id: number) => {
    const response = await client.get<any>(`/interaction-areas/${id}`)

    return deserializeInteractionArea(response.data)
}

/**
 * Store a new interaction area
 *
 * @param data
 */
const store = async (data: InteractionAreaData) => {
    const response = await client.post<any>('/interaction-areas', data)
    return deserializeInteractionArea(response.data)
}

/**
 * Update an existing interaction area
 *
 * @param {number} id
 * @param data
 */
const update = async (id: number, data: InteractionAreaData) => {
    const response = await client.put<InteractionArea>(`/interaction-areas/${id}`, data)
    return deserializeInteractionArea(response.data)
}

/**
 * Permanently delete a interaction area
 *
 * @param {number} id
 */
const destroy = async (id: number) => {
    const response = await client.delete<null>(`/interaction-areas/${id}`)
    return response.status === 204
}

const interactionAreas = {
    all,
    filtered,
    get,
    store,
    update,
    destroy
}

export default interactionAreas;